// eslint-disable-next-line no-shadow
export enum Urls {
  INSERT_QUESTIONNAIRE = 'v2/waitingroom/insert-questionnaire',
}
